<template>
  <div class="js-modal hidden fixed inset-0 z-40 flex justify-center items-center" @click="showModal">
    <div class="body bg-white w-10/12 sm:w-1/2 md:w-400 z-50 p-8 flex flex-col items-center">
      <svg-vue icon="adore-me-logo" class="mb-4 h-6 fill-current text-primary-900"></svg-vue>

      <div class="text-sm text-center">
        <div>Hi there!</div>
        <div v-text="message"></div>
      </div>
      <form @submit.prevent="continueRegister">
        <input v-model="form.instagramHandle" type="hidden" />

        <div class="form-group mt-4">
          <label for="email">Email</label>
          <input v-model="form.email" type="email" placeholder="jane@doe.com" />
        </div>

        <div class="form-group" :class="{ hidden: !passwordIsVisible }">
          <label for="password">Password</label>
          <input v-model="form.password" type="password" placeholder="password" />
        </div>

        <div class="form-group" :class="{ hidden: !nameIsVisible }">
          <label for="name">Your name</label>
          <input v-model="form.name" type="text" placeholder="Jane Doe" />
        </div>

        <div class="form-group" :class="{ hidden: !nameIsVisible }">
          <label for="agreedToTc">
            <input id="agreedToTc" v-model="form.agreedToTc" type="checkbox" name="agreedToTc" />
            I agree with the
            <a class="inline-block" href="https://creators.adoreme.com/terms" target="_blank">Terms &amp; Conditions</a>
          </label>
        </div>

        <button v-promise-btn class="mb-4 w-full" type="submit" @click.prevent="continueRegister">Continue</button>
      </form>

      <div class="text-sm text-center mt-4">
        By signing up, you agree to our
        <a href="https://creators.adoreme.com/terms" target="_blank">Terms &amp; Conditions</a> and
        <a href="https://creators.adoreme.com/privacy" target="_blank">Privacy Policy</a>.
      </div>
    </div>
    <div class="backdrop fixed bg-black opacity-50 w-full h-full inset-0 z-30"></div>
  </div>
</template>

<script>
export default {
  name: 'LoginModal',
  props: {
    instagramHandle: {
      type: String,
    },
  },
  data: () => ({
    form: {
      name: '',
      email: '',
      password: '',
      instagramHandle: '',
      agreedToTc: '',
    },
    message: 'Enter your email to get started',
    nextAction: 'register',
    passwordIsVisible: false,
    nameIsVisible: false,
  }),
  mounted() {
    this.form.instagramHandle = this.instagramHandle;
  },
  methods: {
    showModal() {
      document.querySelector('.js-modal').classList.toggle('hidden');
      document.querySelector('body').classList.toggle('overflow-hidden');
    },
    async continueRegister() {
      if (!this.form.email) return;
      if (this.form.email.length < 3) return;

      await this.checkEmail();

      this.message = 'Enter your password';

      if (this.form.password.length < 3) return;

      if (this.nameIsVisible) this.runNextAction();

      if (this.nextAction === 'register') {
        this.nameIsVisible = true;
        this.message = 'Enter your name';
      } else {
        this.runNextAction();
      }
    },
    async checkEmail() {
      const { data } = await window.axios.post('/register/check-email', { email: this.form.email });

      if (data && data.success) {
        this.passwordIsVisible = true;

        this.nextAction = data.exists ? 'login' : 'register';
      }
    },
    async runNextAction() {
      let url = '/register';
      let payload = {
        name: this.form.name,
        email: this.form.email,
        password: this.form.password,
        /* eslint-disable camelcase */
        password_confirmation: this.form.password,
        instagram_handle: this.form.instagramHandle,
        agreed_to_tc: this.form.agreedToTc ? 'on' : null,
        /* eslint-enable camelcase */
      };

      if (this.nextAction === 'login') {
        url = '/login';
        payload = {
          email: this.form.email,
          password: this.form.password,
        };
      }

      await window.axios.post(url, payload);
    },
  },
};
</script>
